import RandingStyle9 from "../../randing/RandingStyle9";

function Randing045({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle9
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/045/24123001.jpg`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/045/24123002.jpg`}
      formFieldColor="white"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      companyName="검단뉴욕치과의원"
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/045/24123003.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/045/24123004.jpg`}
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/045/24123005.jpg`}
      img6Path={`${process.env.REACT_APP_CDN_BASE}/images/045/24123006.jpg`}
      callNumber={"tel:032-567-8528"}
      privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      eventDates={true}
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan.png`}
    />
  );
}

export default Randing045;
